export default "__VITE_ASSET__Pm7$fKat__"